export default {
    "navigation": {
        "allWatchfaces": "Všechny aplikace",
        "faq": "FAQ",
        "helpCenter": "Nápověda a návody",
        "newsletter": "Newsletter",
        "contact": "Kontakt",
        "weatherProvider": "Poskytovatel Počasí",
        "tides": "Přílivy",
        "colors": "Barvy",
        "fonts": "Písma"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "Moderní Garmin aplikace s pokročilými funkcemi pro všechny vaše aktivity",
        "newBadge": "Nové",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Často kladené otázky",
        "subtitle": "Najděte odpovědi na běžné otázky o našich watchface",
        "tabs": {
            "search": "Hledat",
            "categories": "Kategorie",
            "trending": "Trending"
        },
        "search": {
            "placeholder": "Hledat pomoc...",
            "button": "Hledat",
            "suggestions": "Populární vyhledávání",
            "tips": {
                "title": "Tipy pro vyhledávání",
                "keywords": "Používejte konkrétní klíčová slova jako \"GPS\", \"počasí\" nebo \"nastavení\"",
                "language": "Vyhledávání funguje ve vašem vybraném jazyce",
                "categories": "Procházejte kategorie pro organizovanou pomoc"
            }
        },
        "noResults": {
            "title": "Nebyly nalezeny žádné výsledky",
            "description": "Zkuste jiná klíčová slova nebo procházejte kategorie",
            "browseCategories": "Procházet kategorie"
        },
        "suggestions": {
            "title": "Populární vyhledávání"
        },
        "trending": {
            "title": "Trending vyhledávání"
        },
        "categories": {
            "title": "Procházet podle kategorie",
            "items": "položky",
            "allItems": "Všechny FAQ položky",
            "allItemsDescription": "Procházejte všechny často kladené otázky",
            "noItems": {
                "title": "Žádné položky v této kategorii",
                "description": "Zkuste vybrat jinou kategorii"
            },
            "viewMore": "Zobrazit všechny položky"
        },
        "results": {
            "title": "Výsledky vyhledávání",
            "found": "výsledků nalezeno pro",
            "total": "Celkové výsledky",
            "bestMatch": "Nejlepší shoda",
            "categories": "Kategorie",
            "sortBy": "Seřadit podle",
            "sort": {
                "relevance": "Relevance",
                "priority": "Priorita",
                "category": "Kategorie"
            },
            "lastUpdated": "Naposledy aktualizováno",
            "matchedIn": "Shoda v",
            "footer": "Nenašli jste to, co jste hledali?",
            "browseCategories": "Procházet kategorie",
            "viewTrending": "Zobrazit trending",
            "contactSupport": "Kontaktovat podporu"
        },
        "actions": {
            "copy": "Kopírovat",
            "share": "Sdílet",
            "copyAnswer": "Kopírovat odpověď",
            "copyAll": "Kopírovat vše"
        },
        "loading": "Načítání FAQ...",
        "error": "Chyba při načítání",
        "retry": "Zkusit znovu"
    },
    "guides": {
        "backToHelp": "Zpět",
        "purchase": {
            "title": "Nákup a instalace",
            "tabs": {
                "installation": "Instalace",
                "versions": "Verze VX / Elite",
                "troubleshooting": "Řešení problémů"
            },
            "installation": {
                "title": "Instalace ciferníků přes aplikaci ConnectIQ",
                "intro": "Ciferníky lze nainstalovat na hodinky přes aplikaci Garmin ConnectIQ pro Android nebo iOS.",
                "step1": "Propojte hodinky s telefonem přes Bluetooth a otevřete aplikaci ConnectIQ na telefonu.",
                "step2": "Přejděte na stránku ciferníku, který chcete nainstalovat.",
                "step3": "Klepněte na tlačítko \"Nainstalovat\". Ciferník se zařadí do fronty a nainstaluje se na hodinky.",
                "step4": "Po instalaci uvidíte zprávu v aplikaci nebo na hodinkách a ciferník bude k dispozici na zařízení.",
                "noteScreen": "Během instalace a aktualizací nenechávejte zhasínat obrazovku telefonu a mějte aplikaci ConnectIQ otevřenou.",
                "selectWatchfaceTitle": "Výběr ciferníku na hodinkách",
                "selectWatchfaceIntro": "Pokud je ciferník nainstalován, ale ještě není vidět, může být potřeba vybrat ho v systémovém menu hodinek.",
                "select1": "Stiskněte a držte tlačítko menu na hodinkách (nebo odpovídající tlačítko na dotykových zařízeních) pro otevření systémového menu.",
                "select2": "Přejděte na položku \"Ciferníky\" nebo \"Designy zobrazení\".",
                "select3": "Uvidíte seznam všech nainstalovaných ciferníků. Použijte tlačítka nahoru/dolů nebo dotykový displej k navigaci.",
                "select4": "Potvrďte vybraný ciferník tlačítkem v pravém horním rohu. Ciferník je nyní aktivní na hodinkách."
            },
            "versions": {
                "title": "VX vs Elite – jaký je rozdíl?",
                "sameFeatures": "Technicky jsou obě verze totožné a nabízejí stejné funkce. Jediný rozdíl je způsob nákupu a aktivace.",
                "eliteTitle": "Verze Elite (Garmin Pay)",
                "elite1": "Samostatná instalace ciferníku zakoupeného přímo přes Garmin Pay v obchodě ConnectIQ.",
                "elite2": "Verze Elite je vázaná na váš účet Garmin. Při koupi nových hodinek můžete Elite ciferník znovu nainstalovat bez dalšího klíče.",
                "elite3": "Garmin Pay není podporován na všech modelech a nemusí být dostupný ve všech zemích.",
                "eliteNoKey": "Důležité: Při nákupu verze Elite přes Garmin Pay se neodesílá žádný odemykací kód. Verze Elite se odemkne přímo po nákupu a nevyžaduje kód.",
                "vxTitle": "Verze VX / z webu",
                "vx1": "Kompatibilní s větším počtem zařízení a často dostupná i když Garmin Pay není.",
                "vx2": "Obsahuje vestavěnou několikadenní zkušební dobu.",
                "vx3": "Po zkušební době můžete na tomto webu zakoupit odemykací kód a trvale odemknout verzi VX (nebo její pro funkce).",
                "vx4": "Odemykací kód platí vždy jen pro zařízení, pro které byl zakoupen (WatchfaceID).",
                "vx5": "Pokud vám Garmin v rámci záruky vymění hodinky, lze vygenerovat nový klíč. V takovém případě nás kontaktujte přes kontaktní formulář."
            },
            "website": {
                "title": "Nákup přes web (verze VX / běžné)",
                "step1": "Nejprve nainstalujte ciferník na hodinky (viz záložka Instalace). WatchfaceID se v nastavení ciferníku zobrazí až po instalaci.",
                "step2": "Otevřete nastavení ciferníku (přes aplikaci ConnectIQ nebo Garmin Express) a zkopírujte WatchfaceID z horního pole.",
                "step3": "Na tomto webu vyberte příslušný ciferník a zadejte WatchfaceID do objednávkového formuláře.",
                "step4": "Dokončete platbu. Odemykací kód obdržíte e-mailem a můžete ho zadat do pole klíče v nastavení ciferníku.",
                "noteNoAutoInstall": "Důležité: Nákup odemykacího kódu přes web ciferník na hodinky automaticky nenainstaluje. Kroky instalace výše je třeba provést ručně."
            },
            "troubleshooting": {
                "installationTitle": "Problémy s instalací (fronta / zaseklé aktualizace)",
                "installationIntro": "Někdy instalace selže, ciferník zůstane dlouho ve frontě nebo aplikace ConnectIQ hlásí nekonečné aktualizace.",
                "installationCause": "To obvykle souvisí s aplikací ConnectIQ nebo službami Garmin, ne s ciferníkem samotným.",
                "installationFix1": "Restartujte hodinky a aplikaci ConnectIQ na telefonu.",
                "installationFix2": "Zkuste instalaci znovu a zajistěte, že se obrazovka telefonu nevypíná a aplikace ConnectIQ zůstane během procesu otevřená.",
                "garminPayTitle": "Nákup Garmin Pay uvízl ve stavu \"probíhá\"",
                "garminPayText": "Pokud nákup přes Garmin Pay v obchodě ConnectIQ dlouho zůstává ve stavu \"probíhá\", řeší to výhradně Garmin. Jako vývojáři nemáme na systém Garmin Pay vliv. V takovém případě kontaktujte oficiální podporu Garmin.",
                "noKeyTitle": "Po nákupu na webu jsem neobdržel odemykací klíč",
                "noKey1": "Nejprve zkontrolujte složku spam ve své e-mailové schránce. E-maily s klíči tam často končí.",
                "noKey2": "V mnoha případech překlep v e-mailu zamezí doručení. Pokud e-mail nenajdete, kontaktujte nás.",
                "noKey3": "a uveďte e-mail použitý k platbě a pokud možno WatchfaceID.",
                "noKeyElite": "Pozn.: Při nákupu verze Elite přímo přes Garmin Pay v obchodě ConnectIQ se neodesílá odemykací kód. Verze Elite se odemkne ihned po nákupu a nevyžaduje kód."
            },
            "contactLink": "Kontaktní formulář"
        },
        "timezones": {
            "title": "Časová pásma a posun UTC",
            "basicsTitle": "Co jsou 2. a 3. časové pásmo?",
            "basicsText": "U mnoha ciferníků můžete nastavit dvě další časová pásma. Obvykle se jmenují \"Druhé časové pásmo\" a \"Třetí časové pásmo\" a zobrazují se v oddělených polích na ciferníku.",
            "offsetTitle": "Nastavení posunů UTC",
            "offsetIntro": "V nastavení ciferníku je obvykle pole, kde můžete zadat posuny druhého a třetího pásma v minutách vůči UTC.",
            "offsetFormat": "První hodnota je posun druhého pásma, druhá hodnota třetího. Hodnoty se uvádějí v minutách, oddělené mezerou. Znaménko + se nepřidává automaticky, kladné hodnoty tedy zadávejte bez +.",
            "exampleLabel": "Příklad:",
            "exampleExplanation": "Zde druhé pásmo má posun -4,5 h (−270 min) a třetí +2 h (+120 min), vždy vůči UTC.",
            "changeExample": "Chcete-li nastavit druhé pásmo na +6 h, první hodnota musí být 360 (6 × 60). S výše uvedeným příkladem by to bylo:",
            "advancedTitle": "Pokročilé možnosti (přípona A/B/C)",
            "advancedOptionalHint": "Tato sekce je volitelná. Platí jen tehdy, pokud váš ciferník podporuje přípony A/B/C.",
            "advancedIntro": "Zda ciferník tyto přípony podporuje, je uvedeno v popisu nad polem posunu v nastavení ciferníku. Pokud ano, můžete vidět popis podobný:",
            "advancedExample": "Posun UTC 2. a 3. pásma v minutách (oddělit mezerou) (písmena za posuny: A - 12h formát, B - 24h formát, C - vojenský formát, prázdné - výchozí)",
            "advancedNote": "Tato volitelná písmena (A/B/C) řídí formát zobrazení daného pásma u některých ciferníků. Používejte je jen tehdy, pokud to popis ciferníku uvádí.",
            "exampleSectionTitle": "Krok za krokem: Příklad pro různá města a formáty",
            "exampleIntro": "Následující příklad ukazuje, jak nastavit 2. pásmo (např. New York) a 3. (např. Tokio) a volitelně 12h nebo 24h zobrazení pro každé.",
            "exampleStep1Title": "Krok 1: Posun UTC pro 2. pásmo",
            "exampleStep1Text": "Zvolte město nebo oblast pro 2. pásmo. Převeďte jeho časový rozdíl oproti UTC na minuty. Např.: New York (EST, UTC−5) → −300 minut. Zadejte tuto hodnotu jako první do pole.",
            "exampleStep2Title": "Krok 2: Posun UTC pro 3. pásmo",
            "exampleStep2Text": "To samé pro 3. pásmo. Např.: Tokio (JST, UTC+9) → 540 minut. To je druhá hodnota, oddělená mezerou od první.",
            "exampleOnlyOffsets": "Pokud ciferník nepoužívá přípony A/B/C, jste hotovi. Zadejte:",
            "exampleStep3Title": "Krok 3: Volitelná přípona formátu (A/B/C)",
            "exampleStep3Optional": "Tento krok je volitelný: přípony můžete vynechat i když je ciferník podporuje; pak se použije výchozí formát. Chcete-li vynutit 12h, 24h nebo vojenský formát pro pásmo, přidejte písmeno hned za posun — bez mezery.",
            "exampleStep3Text": "Příklad: formát 12h pro New York (A) a 24h pro Tokio (B):",
            "exampleStep3Note": "Bez přípony = výchozí zobrazení ciferníku (často 24h). Zda jsou přípony podporovány, je uvedeno v popisu nad polem posunu v nastavení ciferníku.",
            "exampleFormatTitle": "Jak se zobrazuje čas s A, B, C",
            "exampleFormatIntro": "Pro tentýž okamžik se zobrazení liší podle formátu (např. 2. pásmo New York -300, 3. pásmo Tokio 540). Živý náhled:",
            "zone2": "2. pásmo",
            "zone3": "3. pásmo",
            "exampleTableTitle": "Odkaz: Posuny UTC pro vybraná města (minuty)",
            "exampleTableIntro": "Základní čas; letní čas se může lišit. Vynásobte hodiny 60."
        },
        "switchViews": {
            "title": "Přepínané pohledy a ovládání gesty",
            "wordLabel": "přepínaný pohled",
            "basicsTitle": "Co jsou přepínané pohledy?",
            "basicsText": "Mnoho ciferníků může zobrazovat různé informace ve stejné oblasti obrazovky. Tyto alternativní stránky se často jmenují \"Switchview\" ({{wordLabel}}), \"Switchview 2\", \"Horní pohled 1/2\", \"Dolní pohled 1/2\" nebo podobně v nastavení.",
            "proNote": "Často jsou tyto další pohledy pro funkce dostupné v zkušební době a poté vyžadují aktivační klíč.",
            "gestureTitle": "Přepínání pohledů gestem zápěstí",
            "gestureIntro": "Na hodinkách bez kompatibilního dotykového displeje lze pohledy měnit druhým pohybem zápěstí.",
            "gestureStep1": "Zvedněte zápěstí jako obvykle pro probuzení displeje. Sekundy nebo rozsvícený displej značí aktivní režim.",
            "gestureStep2": "Během několika sekund (cca 7) proveďte pohyb zápěstí znovu – ne příliš prudce, ale dostatečně zřetelně, aby ho hodinky rozpoznaly.",
            "gestureStep3": "Pokud ciferník podporuje přepínané pohledy, nakonfigurované oblasti (např. horní/dolní pohled) přepnou na další stránku.",
            "gestureHint": "Pokud se nic nemění, zkontrolujte nastavení: některé pohledy je třeba explicitně přiřadit (např. \"Horní pohled 2\" / \"Dolní pohled 2\").",
            "touchTitle": "Přepínané pohledy na dotykových zařízeních",
            "touchIntro": "Na novějších hodinkách s kompatibilním dotykovým displejem (např. Fenix 7 a novější) lze pohledy často měnit i stiskem určitých zón.",
            "touchConfig": "U mnoha ciferníků lze tyto zóny nastavit v nastavení, často níže. Typické příklady jsou číslice hodin a minut nebo oddělené oblasti na displeji.",
            "touchHold": "Je-li nakonfigurovaná dotyková zóna, dlouhý stisk příslušné číslice/oblasti přepne přiřazený pohled.",
            "touchMultiple": "Některé ciferníky nabízejí několik zón přiřaditelných zvlášť – např. jednu pro horní a jednu pro dolní pohled.",
            "touchInfo": "Pokud má ciferník speciální zóny, jsou obvykle popsány v informačním textu na tomto webu nebo v obchodě ConnectIQ."
        },
        "findWfId": {
            "title": "Jak najít WatchfaceID",
            "whatIs": "Co je WatchfaceID?",
            "whatIsExplanation": "Každý ciferník má na zařízení jedinečné WatchfaceID. Jde o 5–6místné číslo. Toto ID je potřeba pro nákup aktivačního kódu nebo pro podporu.",
            "connectIqTitle": "Přes aplikaci ConnectIQ (doporučeno)",
            "ciq1": "Zajistěte, že jsou hodinky připojeny k telefonu přes Bluetooth.",
            "ciq2": "Otevřete aplikaci ConnectIQ na telefonu.",
            "ciq3": "Přejděte na stránku ciferníku s popisem a obrázky. Pokud ji nenajdete, použijte lištu \"Hledat\" dole nebo vyhledejte v \"Moje ciferníky\" v sekci \"Zařízení\".",
            "ciq4": "Stiskněte tlačítko \"Nastavení\" na stránce ciferníku pro otevření všech nastavení.",
            "ciq5": "WatchfaceID je v horním poli. Zkopírujte nebo napište toto číslo – toto je ID potřebné k platbě.",
            "keyEntryTitle": "Zadání aktivačního klíče",
            "keyEntryExplanation": "V řádku pod polem WatchfaceID najdete pole pro klíč/kód zasílaný po platbě. Některé ciferníky tam zobrazují zbývající zkušební dny – smažte to před zadáním klíče.",
            "garminExpressTitle": "Přes Garmin Express (počítač)",
            "ge1": "Nainstalujte Garmin Express a připojte hodinky k počítači.",
            "ge2": "Přejděte do seznamu nainstalovaných ciferníků.",
            "ge3": "Klepněte na tlačítko se třemi tečkami u ciferníku pro otevření nastavení.",
            "ge4": "Postupujte stejně jako u aplikace ConnectIQ.",
            "geNote": "Pozn.: Doporučuje se aplikace ConnectIQ, některé verze Garmin Express mohou způsobovat chyby.",
            "zeroId": "WatchfaceID zobrazuje 0?",
            "zeroIdExplanation": "Někdy WatchfaceID zobrazuje 0. To obvykle napraví jednorázové uložení nastavení nebo restart hodinek. Pokud stále zobrazuje 0, platba by i tak měla fungovat."
        },
        "location": {
            "title": "Nastavení GPS a polohy",
            "whatIsGpsFix": "Co je fix GPS?",
            "gpsFixExplanation": "Fix GPS sdělí ciferníku, kde jste, aby mohl správně spočítat časy východu/západu slunce, fáze Měsíce, polohu pro počasí a přílivy.",
            "howTo": "Jak provést fix GPS",
            "step1": "Na hodinkách přejděte na úvodní obrazovku libovolné aktivity (např. \"Běh\")",
            "step2": "Počkejte, až hodinky zachytí GPS signál (zelený pruh/ikona)",
            "step3": "Vraťte se na ciferník – data by se měla během pár minut aktualizovat",
            "alternative": "Alternativa: GPS telefonu",
            "alternativeExplanation": "GPS můžete zapnout i na telefonu. Hodinky musí být připojeny přes Bluetooth. Tato metoda je pomalejší, ale funguje stejně.",
            "requirements": "Požadavky",
            "req1": "Hodinky připojeny k telefonu přes Bluetooth",
            "req2": "Aplikace Garmin Connect (ne ConnectIQ) běží alespoň na pozadí",
            "req3": "GPS na telefonu zapnuto pro polohu z telefonu"
        },
        "settings": {
            "tabs": { "options": "Možnosti datových polí", "change": "Změnit nastavení", "troubleshoot": "Řešení problémů" },
            "title": "Nastavení watchface",
            "optionsIntro": "Obecný seznam možností datových polí. Klikněte pro popis. Ne všechny možnosti jsou na všech watchface.",
            "change": {
                "title": "Jak změnit nastavení watchface",
                "intro": "Nastavení watchface se mění v aplikaci ConnectIQ v telefonu.",
                "step1": "Propojte hodinky s telefonem přes Bluetooth a otevřete aplikaci ConnectIQ (ne Connect).",
                "step2": "Přejděte na stránku watchface. Není-li nainstalován, nejdříve ho nainstalujte.",
                "step3": "Na stránce watchface najdete tlačítko „Nastavení“ – klepněte pro otevření seznamu.",
                "step4": "Zde můžete měnit všechna datová pole, barvy a pokročilé možnosti.",
                "step5": "Klepněte na tlačítko uložit v pravém horním rohu pro přenos nastavení na hodinky.",
                "installLink": "Návod k instalaci"
            },
            "troubleshoot": {
                "title": "Řešení problémů",
                "cantSave": { "q": "Nastavení nelze uložit", "a1": "Někdy mají servery Garmin potíže s určitými znaky.", "a2": "Vyprázdněte pole barevného schématu (pokud je) a uložte znovu." },
                "wontOpen": { "q": "Nastavení se neotevře", "a1": "Úplně zavřete aplikaci ConnectIQ a v případě potřeby restartujte hodinky.", "a2": "Vidíte-li jen tlačítko „Instalovat“, watchface ještě není nainstalován." },
                "missingOptions": { "q": "Nemohu najít určitou možnost nastavení", "a": "Ne všechny možnosti jsou na všech zařízeních k dispozici." },
                "naValue": { "q": "Pole zobrazuje jen „n/a“", "a": "Vaše zařízení tuto možnost nepodporuje (starší model nebo chybějící hardware)." }
            }
        },
        "dateFormat": {
            "title": "Vlastní formát data (Datum 1 / 2 / 3)",
            "basicsTitle": "K čemu slouží pole formátu data?",
            "basicsIntro": "V nastavení watchface jsou dvě pole (nebo tři), kterými lze nastavit zobrazení Data 1, Data 2 a případně Data 3. Zadaná písmena určují formát.",
            "notAll": "Není k dispozici na všech watchface.",
            "where": "Pole jsou obvykle níže v nastavení, pod možnostmi datových polí.",
            "codesTitle": "Kódy formátu",
            "codesIntro": "V poli formátu můžete použít následující písmena. Výstup odpovídá aktuálnímu datu.",
            "codeD": "den v měsíci (s úvodní nulou)",
            "codeDText": "den jako text (např. pondělí)",
            "codeM": "měsíc číslem (s úvodní nulou)",
            "codeMText": "měsíc jako text",
            "codeY": "rok dvoumístně",
            "codeY4": "rok čtyřmístně",
            "codeJ": "juliánské datum (vojenské)",
            "codeW": "týden v roce",
            "codeO": "měsíc bez úvodní nuly",
            "codeN": "den bez úvodní nuly",
            "codeP": "den v roce",
            "exampleHint": "Např. „D, d.M.Y“ může zobrazit „Po, 27.02.2026“."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Jak fungují motivy?:",
            "description": "Nahoře v nastavení ciferníku máte \"řetězec motivu\", který reprezentuje aktuální nastavení barev (ikony, graf, čas atd.). Pokud něco změníte (např. barvu horní sekce) a stisknete \"Uložit\", řetězec motivu se při příštím otevření nastavení aktualizuje. Tím si můžete uložit barevné nastavení zkopírováním a uložením řetězce jinde. Můžete ho i sdílet s ostatními (např. v recenzích/fóru) a použít řetězec jiných lidí k vyzkoušení jiných stylů."
        },
        "dynamicThemeSwitching": {
            "title": "Dynamické přepínání motivu:",
            "sunset": {
                "title": "Přepnutí po západu slunce / před východem -",
                "description": "pokud před řetězec motivu, na který chcete přepnout, v poli řetězce motivu dáte vykřičník !, uloží se jako motiv po západu slunce (příklad: !UEUE[UEUEEEEEEU^). Můžete to kdykoli změnit zadáním řetězce s úvodním ! do pole. Chcete-li odstranit motiv na noc, zadejte do pole jen ! a přepínání se zastaví."
            },
            "lowPower": {
                "title": "Přepnutí v režimu úspory -",
                "description": "postup je stejný jako u nastavení motivu západ/východ výše, místo ! dejte před řetězec motivu # (příklad: #UEUE[UEUEEEEEEU^). Každé hodinky přejdou do \"Režimu úspory\" asi po 10 sekundách dívání na hodinky nebo návratu z menu. Sekundy v režimu úspory obvykle mizí (lze změnit v nastavení ciferníku). Obě možnosti (@noc/@úspora) lze kombinovat. Po nastavení není dynamický řetězec motivu v nastavení ciferníku vidět, proto si ho uložte jinde, pokud ho budete chtít v budoucnu upravit."
            }
        }
    },
    "helpCenter": {
        "title": "Nápověda a návody",
        "subtitle": "Odpovědi, návody a instrukce pro vaše watchface",
        "guidesTitle": "Návody a instrukce",
        "faqTitle": "Často kladené otázky",
        "allCategories": "Vše",
        "guides": "Návody",
        "faqResults": "FAQ",
        "noResults": "Nebyly nalezeny žádné výsledky",
        "noResultsHint": "Zkuste jiná klíčová slova nebo procházejte kategorie a návody níže."
    },
    "watchfacesOverview": {
        "title": "Všechny aplikace",
        "loading": "Načítání watchfaces...",
        "error": "Chyba při načítání watchfaces",
        "retry": "Zkusit znovu",
        "noWatchfaces": "Žádné watchfaces k dispozici"
    },
    "detailTabs": {
        "payment": "Platba",
        "themes": "Témata",
        "info": "Info",
        "instructions": "Návody",
        "instructionsIntro": "Všechny návody a instrukce na jednom místě:",
        "noThemes": "Pro toto watchface nejsou k dispozici žádná barevná témata."
    },
    "watchfaceDetail": {
        "loading": "Načítání watchface...",
        "error": {
            "notFound": "Watchface nenalezeno",
            "loading": "Chyba při načítání watchface"
        },
        "backToOverview": "Zpět na přehled",
        "goToStore": "Přejít do IQ Store",
        "goToTrial": "Zkušební verze",
        "devices": "zařízení",
        "info": {
            "title": "Funkce",
            "tides": "🌊 Informace o přílivech s automatickými aktualizacemi",
            "weather": "🌤️ Počasí z OpenWeatherMap a Yr",
            "colors": "🎨 Barevná témata a přizpůsobení",
            "location": "📍 Určení polohy pomocí GPS",
            "faq": "❓ FAQ a podpora",
            "weatherFallback": "Bez předplatného One Call 3.0 používá klíč API OpenWeatherMap poskytovatele \"Yr\" jako zálohu."
        }
    },
    "colorThemes": {
        "clickToCopy": "Klikněte pro kopírování",
        "clickToPreview": "Klikněte pro náhled",
        "closePreview": "Zavřít náhled",
        "copied": "Zkopírováno!",
        "useInSettings": "Použijte v nastavení watchface",
        "guideLink": "Více o tématech a řetězcích témat",
        "deviceNote": "Barevná témata nejsou na všech zařízeních k dispozici.",
        "noFieldNote": "Pokud nastavení vašeho watchface nemá samostatné pole pro barevná schémata, nejsou pro váš model hodinek na tomto watchface podporována."
    },
    "payment": {
        "option1": {
            "title": "Možnost 1: Garmin Pay",
            "description": "Zakupte placené watchface přes Garmin Pay v ConnectIQ Store (pokud je hodinky podporováno).",
            "link": "Odkaz na ConnectIQ Store"
        },
        "option2": {
            "title": "Možnost 2: Přímá platba přes WatchfaceID",
            "description": "Pokud vaše hodinky nejsou podporovány Pro verzí, můžete zakoupit klíč Trial/VX zadáním WatchfaceID.",
            "vxNote": "Toto je klíč pro VX verzi watchface, ne pro verzi Garmin Pay!",
            "vxLink": "Odkaz na VX verzi"
        },
        "tax": "DPH",
        "wfid": {
            "description": "Zadejte WatchfaceID (v nastavení watchface)",
            "placeholder": "Zadejte WatchfaceID (5-6 číslic)",
            "guideLink": "Jak najít WatchfaceID",
            "guideLinkShort": "Zobrazit návod"
        },
        "wfidError": {
            "letters": "WatchfaceID smí obsahovat pouze číslice",
            "tooLong": "WatchfaceID by měla mít 5-6 číslic",
            "invalid": "Zadejte platnou WatchfaceID (5-6 číslic)",
            "lengthHint": "WatchfaceID má obvykle 5-6 číslic. Zkontrolujte."
        },
        "errors": {
            "empty": "Zadejte WatchfaceID",
            "invalid": "Zadejte platnou WatchfaceID",
            "config": "Chyba konfigurace platby",
            "checkout": "Nepodařilo se otevřít platbu. Zkuste znovu."
        },
        "buy": "Koupit nyní",
        "selectMethod": "Vyberte svou verzi",
        "versionSelectHint": "Jedná se o dvě samostatné verze — vyberte prosím tu správnou:",
        "vxWarning": "Verze VX a Elite jsou samostatně stažitelné verze ciferníku. Aktivační kód pro verzi VX NEODEMYKÁ verzi Elite.",
        "beta": {
            "title": "Aktuálně v betě",
            "description": "Během této beta fáze můžete tento watchface používat zcela zdarma. Po skončení zkušebního období nebudou účtovány žádné automatické poplatky. V tomto období jsou testovány nové funkce a vylepšení. Díky za vaši zpětnou vazbu!",
            "descriptionApp": "Během této beta fáze můžete tuto aplikaci používat zcela zdarma. Po skončení zkušebního období nebudou účtovány žádné automatické poplatky. V tomto období jsou testovány nové funkce a vylepšení. Díky za vaši zpětnou vazbu!"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite verze",
            "description": "Toto watchface je k dispozici pouze přes Garmin Pay v ConnectIQ Store.",
            "comboDescription": "Kupte přes Garmin Pay v ConnectIQ Store. Samostatná verze.",
            "compatibility": "Garmin Pay není podporován na všech hodinkách. Zkontrolujte kompatibilitu na stránce Store. Jinak stáhněte VX verzi (technicky identická).",
            "storeLink": "Otevřít v ConnectIQ Store",
            "moreGuide": "Potřebujete více o rozdílu Elite / VX?",
            "moreGuideLink": "Přečtěte si návod k nákupu a instalaci",
            "eliteNoKey": "Při nákupu Elite verze přes Garmin Pay není odeslán žádný odemykací kód. Elite verze je odemčena přímo po nákupu a nevyžaduje kód.",
            "accountBound": "Nákup přes Garmin Pay je vázán na váš Garmin účet a automaticky dostupný pro vaše budoucí zařízení (pokud jsou kompatibilní).",
            "eliteNoKeyAndGuide": "Při nákupu přes Garmin Pay není odeslán žádný kód — Elite verze je odemčena přímo po nákupu. Více detailů v návodu k nákupu a instalaci."
        },
        "vx": {
            "badge": "Všechna zařízení",
            "title": "VX verze",
            "description": "Kompatibilní se všemi podporovanými zařízeními. Stáhněte zkušební verzi z ConnectIQ Store a aktivujte zde zakoupeným kódem.",
            "trialNote": "VX verze obsahuje zkušební období. Poté zakupte aktivační kód níže pro odemčení.",
            "deviceBound": "Aktivační kód je vázán na vaše zařízení a odemyká VX verzi trvale.",
            "moreGuide": "Více o VX verzi, klíčích nebo instalaci?",
            "moreGuideLink": "Přečtěte si návod k nákupu a instalaci",
            "downloadLink": "Stáhnout VX verzi",
            "details": {
                "line1": "Po platbě bude aktivační klíč odeslán na e-mail, který zadáte v dalším kroku.",
                "line2": "Ověřte, že e-mailová adresa je správná.",
                "line3": "Po platbě zkontrolujte složku spam – e-maily s klíči tam často končí.",
                "line4": "Všechny platby zpracovává Paddle; účet není potřeba.",
                "line5": "Pro podporu použijte kontaktní formulář nebo nástroj ConnectIQ Store.",
                "line6": "Jiné dotazy nelze vyřídit."
            }
        },
        "standalone": {
            "title": "Koupit aktivační kód",
            "description": "Kupte aktivační kód zadáním WatchfaceID níže. Kód vám bude okamžitě odeslán."
        },
        "checkoutOpening": "Otevírání platby...",
        "info": {
            "key": "Po nákupu obdržíte klíč k zadání v nastavení watchface.",
            "activation": "Klíč se aktivuje ihned po platbě.",
            "support": "Při dotaze kontaktujte podporu.",
            "moreGuide": "Více o nákupu a instalaci"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Kreditní karta"
        }
    },
    "footer": {
        "tagline": "Moderní Garmin aplikace s pokročilými funkcemi pro všechny aktivity.",
        "description": "Moderní Garmin aplikace s pokročilými funkcemi pro všechny aktivity."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Přihlaste se k odběru newsletteru pro novinky o watchfacech, funkcích a akcích.",
        "frequencyHint": "Přibližně jeden e-mail za dva měsíce. Odhlášení kdykoli možné.",
        "emailPlaceholder": "Vaše e-mailová adresa",
        "subscribe": "Odebírat",
        "unsubscribe": "Odhlásit",
        "subscribeSuccess": "Úspěšně přihlášeno! Zkontrolujte e-mail.",
        "subscribeError": "Došlo k chybě. Zkuste to prosím později.",
        "unsubscribeSuccess": "Úspěšně odhlášeno.",
        "unsubscribeError": "Došlo k chybě. Zkuste to prosím později."
    },
    "contact": {
        "title": "Kontakt",
        "description": "Máte otázku nebo potřebujete podporu? Napište mi zprávu.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "vase@email.cz",
        "deviceLabel": "Zařízení (volitelné)",
        "devicePlaceholder": "např. Fenix 7",
        "watchfaceLabel": "Watchface (volitelné)",
        "watchfacePlaceholder": "např. Horizon",
        "messageLabel": "Zpráva",
        "messagePlaceholder": "Vaše zpráva...",
        "send": "Odeslat zprávu",
        "sendAnother": "Odeslat další zprávu",
        "successTitle": "Zpráva odeslána!",
        "successMessage": "Ozvu se vám co nejdříve.",
        "error": "Došlo k chybě. Zkuste to prosím znovu nebo napište přímo na dev@orcatec.net.",
        "rateLimit": "Maximálně 2 zprávy každých 5 minut. Zkuste to prosím později.",
        "consentNotice": "Odesláním souhlasíte se zpracováním údajů v souladu s mými",
        "guidesIntro": "Pokud máte dotazy ke konkrétním funkcím, možná už na ně odpovídají tyto návody:",
        "faqIntro": "K mnoha tématům existuje také podrobné FAQ:",
        "faqLinkLabel": "Otevřít Nápovědu a návody",
        "responseTimeNotice": "Prosím o pochopení, že v rušnějších obdobích může odpověď trvat i několik dní."
    },
    "fonts": {
        "title": "Písma",
        "timefonts": "Písma času",
        "datafonts": "Písma dat"
    },
    "common": {
        "loading": "Načítání...",
        "error": "Chyba",
        "retry": "Zkusit znovu",
        "back": "Zpět",
        "close": "Zavřít",
        "save": "Uložit",
        "cancel": "Zrušit",
        "confirm": "Potvrdit",
        "notFound": "404 – Stránka nenalezena"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Aplikace Bierwandern vám umožní sledovat túru a doplňování, kterého si užíváte po cestě. Navíc obsahuje odhad promile s grafem (hrubý odhad) – ale neberte to příliš vážně!",
        "settingsHint": "Na úvodní obrazovce stiskněte tlačítko menu na hodinkách pro otevření nastavení (u hodinek se 2 tlačítky dlouze stiskněte dotykovou obrazovku).",
        "disclaimer": "Výpočet promile je čistě zábavná metrika – algoritmus odhaduje alkohol v krvi podle konzumovaných nápojů a tělesné hmotnosti! Na základě této hodnoty nečinte rozhodnutí – není spolehlivá a nejde o skutečné měření alkoholu!",
        "closing": "Jinak vám přeji krásné túry a dobrou zábavu!",
        "support": "Při problémech nebo návrzích na vylepšení použijte tlačítko «App Support» – děkuji."
    },
    "bodysurf": {
        "intro": {
            "title": "Co je BodySurf?",
            "text": "BodySurf je hodinková aplikace Garmin Connect IQ pro bodysurfing. Pomocí GPS rozpozná jízdu na vlně, měří vzdálenost a délku každé jízdy a přiřadí zábavný název podle ujeté vzdálenosti. Relace se ukládají jako aktivity s jednotlivými okruhy v Garmin Connect."
        },
        "gps": {
            "title": "Před startem – GPS",
            "text1": "Před zahájením relace počkejte na GPS fix. Na úvodní obrazovce se zobrazí „Hledání GPS“, dokud není signál, poté „START pro začátek“.",
            "text2": "Pro nejlepší přesnost aplikace využívá multi-GNSS / dual-band GPS, pokud to hodinky podporují. Chvíli stůjte v klidu u vody, pokud fix trvá déle."
        },
        "start": {
            "title": "Úvodní obrazovka",
            "startBtn": "Spusťte novou relaci, až bude GPS připraveno (START = začít sezení).",
            "menuBtn": "Otevřete nastavení: Jak používat a Jednotky (MENU = nastavení / info).",
            "backBtn": "ZPĚT = opustit aplikaci"
        },
        "during": {
            "title": "Během aktivity",
            "detect": "Jízdy jsou detekovány GPS rychlost automaticky. Použijte ZPĚT pro ruční spuštění/zastavení jízdy. Krátké pohyby pod cca 2 metry se ignorují.",
            "startBtn": "START = zastavit / uložit / pokračovat",
            "backBtn": "ZPĚT = ruční jízda zapnout/vypnout",
            "live": "Během jízdy vidíte aktuální vzdálenost, živý název a „JEZDÍM!“. Po skončení jízdy zůstane název a statistiky viditelné do začátku další jízdy."
        },
        "stop": {
            "title": "Menu zastavení",
            "resume": "Pokračovat",
            "save": "Uložit",
            "discard": "Zahodit"
        },
        "after": {
            "title": "Po sezení",
            "summary": "Souhrn ukazuje čas relace, počet Jízdy, celkovou vzdálenost a Nejlepší jízdu s názvem a statistikami.",
            "rides": "Přejeďte pro zobrazení detailů jízdy. Na hodinkách s tlačítky: << DOWN rides.",
            "finished": "Poté: Nové sezení pomocí START nebo Opustit aplikaci pomocí ZPĚT."
        },
        "titles": {
            "title": "Názvy jízd",
            "intro": "Každá jízda dostane zábavný název na základě vzdálenosti. Čím delší jízda, tím lepší název!",
            "colDistance": "Vzdálenost",
            "colTitle": "Název",
            "th0": "Naplavenina",
            "th1": "Sumýš",
            "th2": "Platýs",
            "th3": "Strašák racků",
            "th4": "Šerif",
            "th5": "Inspektor",
            "th6": "Jezdec vln",
            "th7": "Poradce",
            "th8": "Lamač vln",
            "th9": "Aquaman",
            "th10": "Lidský surf",
            "th11": "Legenda pobřeží",
            "th12": "Poseidon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Uložené relace se v Garmin Connect zobrazí s vlastními poli: název jízdy, vzdálenost okruhu (metry), čas okruhu (sekundy) a nejdelší jízda/čas na úrovni relace. Každá rozpoznaná jízda je uložena jako okruh."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Na Instinct hodinkách subdisplej ukazuje čas, GPS a vzdálenost jízdy. Místo přejetí použijte tlačítko DOWN (<< DOWN rides).",
            "menu": "„Menu“ je vlevo na úvodní obrazovce. Stiskněte START, když na subdispleji svítí GPS OK."
        },
        "settings": {
            "title": "Nastavení",
            "units": "Jednotky: přepínání metrických a imperiálních jednotek pro vzdálenost a rychlost.",
            "info": "Info: nápověda v hodinkách (Jak používat) pro tlačítka během aktivity, po relaci a na úvodní obrazovce."
        },
        "supportBefore": "Při problémech nebo návrzích použijte",
        "supportLink": "kontaktní formulář",
        "supportAfter": " – děkujeme!"
    }
};
